export const AUTH_SESSION_HINT_DOCUMENT_ATTRIBUTE = 'data-auth-session-hint';

export type AuthSessionHintDocumentState = 'present' | 'absent';

export function syncAuthSessionHintDocumentState(
  state: AuthSessionHintDocumentState
) {
  if (typeof document === 'undefined') {
    return;
  }

  if (state === 'present') {
    document.documentElement.setAttribute(
      AUTH_SESSION_HINT_DOCUMENT_ATTRIBUTE,
      'true'
    );
    return;
  }

  document.documentElement.removeAttribute(
    AUTH_SESSION_HINT_DOCUMENT_ATTRIBUTE
  );
}
